











import { Component } from '@niknevis/vue-modules'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import Vue from 'vue'
import { ModelSync } from 'vue-property-decorator'

@Component({
  components: {
    AdminUserSearch
  }
})
export default class AdminAgentSearch extends Vue {
  @ModelSync('value', 'input') users: number | number[]

  protected agentRoles = ['superadmin', 'manager', 'supporter', 'accounting', 'contentmanager']
}
